// extracted by mini-css-extract-plugin
export default {"container":"FridgeLetter_container__n-CNN"};